var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-posts2 section-posts-feed" },
    [
      _c(
        "div",
        { staticClass: "navigations" },
        [
          _c("div", { staticClass: "container-list-avatar" }, [
            _c(
              "div",
              { staticClass: "list-avatar hide-scrollbar" },
              _vm._l(_vm.pagesSelected, function(page) {
                return _c("Avatar", {
                  key: page.id,
                  attrs: {
                    urlPicture: page.avatar,
                    typeNetwork: page.network,
                    checked: _vm.pageSelected && page.id == _vm.pageSelected.id
                  },
                  on: {
                    click: function() {
                      return _vm.selectPage(page)
                    }
                  }
                })
              }),
              1
            )
          ]),
          _c(
            "MainNavigation",
            _vm._g({ attrs: { tabSelected: _vm.tabSelected } }, _vm.$listeners)
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.pageSelected && Object.keys(_vm.groupedItems).length
            ? _c("ListPosts", {
                attrs: { groups: _vm.groupedItems },
                on: {
                  selectEvent: _vm.handleEventClick,
                  changeDate: _vm.changeDate
                }
              })
            : _c("PostNotFound"),
          _c("div", { staticClass: "instagram-app" }, [
            _c(
              "div",
              { staticClass: "container-phone" },
              [
                _c("div", { staticClass: "actions" }, [
                  _c("div", { staticClass: "container-legend" }, [
                    _c(
                      "div",
                      { staticClass: "legend" },
                      _vm._l(["scheduled", "draft", "posted"], function(
                        status
                      ) {
                        return _c("div", { staticClass: "item" }, [
                          _c("div", {
                            staticClass:
                              "circle-status card-status-background-primary-color",
                            class: status
                          }),
                          _c(
                            "p",
                            { staticClass: "card-status-color", class: status },
                            [_vm._v(_vm._s(_vm.$t("dash.post." + status)))]
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _c("div", { staticClass: "btns" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        on: { click: _vm.refreshInstagramData }
                      },
                      [_c("i", { staticClass: "fa-solid fa-rotate" })]
                    ),
                    _vm._m(0),
                    _vm._m(1)
                  ])
                ]),
                _c(
                  "Phone",
                  [
                    _c("InstagramInterface", {
                      attrs: {
                        plannedItems: _vm.plannedItems,
                        postedItems: _vm.postedItems,
                        pinnedItems: _vm.pinnedItems,
                        statsProfile: _vm.statsProfile,
                        page: _vm.pageSelected,
                        loadingCard:
                          this.configFetchItemPosted.isLoading ||
                          !this.configFetchItemPosted.isEnd
                      },
                      on: {
                        changeDate: _vm.changeDate,
                        loadMorePostedItems: _vm.fetchItemPosted
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm.eventSelected
        ? _c("DrawerPost", {
            attrs: { event: _vm.eventSelected },
            on: { close: _vm.closeDrawer, deletePost: _vm.handlerDeletePost }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fa-solid fa-moon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("i", { staticClass: "fa-solid fa-download" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }